import { pxToRem } from '../../../../lib';
export default (function () {
  return {
    'size.half': '50%',
    'size.quarter': '25%',
    'size.small': pxToRem(150),
    'size.medium': pxToRem(200),
    'size.large': pxToRem(300)
  };
});